angular.module 'zc.core'

.factory 'Page', (Environment) ->
  title = 'AiDeal'
  bodyClass = ''
  env = ''
  Environment.get()
  .then (res) ->
    env = res
  page =
    title: ->
      if env is 'production'
        title
      else
        "[#{env}] #{title}"
    setTitle: (newTitle) ->
      if newTitle
        title = "#{newTitle} - AiDeal"
      else
        title = 'AiDeal'
    bodyClass: ->
      bodyClass
    setBodyClass: (newBodyClass) ->
      bodyClass = newBodyClass
  page



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/page_service.js.coffee